/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'checkmark': {
    width: 10,
    height: 8,
    viewBox: '0 0 10 8',
    data: '<path pid="0" d="M3.377 5.414L8.136 1.1a.71.71 0 01.953 1.052l-5.48 4.97a.347.347 0 01-.465.002L.91 5.127a.713.713 0 01.95-1.064l1.517 1.35z" _fill="#fff"/>'
  }
})
